import React, { Component } from "react";
import { PieChart, Legend } from "react-easy-chart";
import styles from "../../assets/css/modules/shared/piechart.css";

function createChartOptions(data) {
  let options = {
    size: 150,
    innerHoleSize: 80,
    data: data,
    styles: {
      ".pie-chart-slice": {
        strokeWidth: 0
      }
    }
  };

  return options;
}

const legendStyle = {
  ".legend": {
    fontSize: "13px"
  }
};

export default class Doughnut extends Component {
  render() {
    var chartOptions = createChartOptions(this.props.data);
    return (
      <div className="d-sm-flex flex-row align-items-center">
        <div className={styles.pieChart}>
          <div className={styles.pieChartCentreValue}>
            {this.props.centreValue}
          </div>
          <PieChart {...chartOptions} />
        </div>
        <div className={styles.legend}>
          <Legend
            data={this.props.data}
            dataId={"key"}
            config={this.props.legendColorConfig}
            styles={legendStyle}
          />
        </div>
      </div>
    );
  }
}
